<template>
    <b-modal
        :title="$t('event-details')"
        v-model="innerValue"
        @change="val => $emit('input', val)"
    >
        <template v-if="event.ttsessiontype || event.ttroom">
            <p class="mb-0"><strong>{{event.ttsessiontype.name}}</strong></p>
            <p class="mb-0" v-if="event.title"><strong>{{ event.title }}</strong></p>
            <p class="mb-0" v-if="event.ttroom">{{ event.ttroom.name }}</p>
            <p class="mb-0" v-if="event.notes">{{ event.notes }}</p>
            <p class="mb-0">
                {{ $datetime.timestampToDate(event.date) }}
                {{ $datetime.timestampToTime(event.from, false) }} -
                {{ $datetime.timestampToTime(event.to, false) }}
            </p>
            <template v-if="event.teachers">
            	<p class="mb-0" v-for="teacher in event.teachers" :key="teacher.id">{{ teacher.user?.displayname || teacher.displayname }}</p>
            </template>
            <div v-if="event.ttroom" class="mt-3">
                <p v-if="event.ttroom.postcode">
                    <template v-if="event.ttroom.address1">{{event.ttroom.address1}}<br></template>
                    <template v-if="event.ttroom.address2">{{event.ttroom.address2}}<br></template>
                    <template v-if="event.ttroom.address3">{{event.ttroom.address3}}<br></template>
                    <template v-if="event.ttroom.address4">{{event.ttroom.address4}}<br></template>
                    <template v-if="event.ttroom.address5">{{event.ttroom.address5}}<br></template>
                    {{event.ttroom.postcode}}
                </p>
                <p v-else-if="event.ttroom.ttbuilding && event.ttroom.ttbuilding.postcode">
                    <template v-if="event.ttroom.ttbuilding.address1">{{event.ttroom.ttbuilding.address1}}<br></template>
                    <template v-if="event.ttroom.ttbuilding.address2">{{event.ttroom.ttbuilding.address2}}<br></template>
                    <template v-if="event.ttroom.ttbuilding.address3">{{event.ttroom.ttbuilding.address3}}<br></template>
                    <template v-if="event.ttroom.ttbuilding.address4">{{event.ttroom.ttbuilding.address4}}<br></template>
                    <template v-if="event.ttroom.ttbuilding.address5">{{event.ttroom.ttbuilding.address5}}<br></template>
                    {{event.ttroom.ttbuilding.postcode}}
                </p>
                <template v-if="event.ttroom.lat && event.ttroom.long">
					<a
						class="btn btn-primary mb-3 mr-3"
						:href="`https://www.google.com/maps/dir/?api=1&destination=${event.ttroom.lat},${event.ttroom.long}`"
						role="link"
						:aria-label="$t('directions-to-destination')"
						target="_blank"
					>{{ $t('view-in-google-maps') }}</a>
					<a
						class="btn btn-primary mb-3"
						:href="`http://maps.apple.com/?address=${event.ttroom.address1},${event.ttroom.address4},${event.ttroom.postcode}&ll=${event.ttroom.lat},${event.ttroom.long}`"
						role="link"
						:aria-label="$t('directions-to-destination')"
						target="_blank"
					>{{ $t('view-in-apple-maps') }}</a>
                </template>
                <template v-else-if="!event.ttroom.postcode && event.ttroom.ttbuilding && event.ttroom.ttbuilding.lat && event.ttroom.ttbuilding.long">
					<a
						class="btn btn-primary mb-3 mr-3"
						:href="`https://www.google.com/maps/dir/?api=1&destination=${event.ttroom.ttbuilding.lat},${event.ttroom.ttbuilding.long}`"
						role="link"
						:aria-label="$t('directions-to-destination')"
						target="_blank"
					>{{ $t('view-in-google-maps') }}</a>
					<a
						class="btn btn-primary mb-3"
						:href="`http://maps.apple.com/?address=${event.ttroom.ttbuilding.address1},${event.ttroom.ttbuilding.address4},${event.ttroom.ttbuilding.postcode}&ll=${event.ttroom.ttbuilding.lat},${event.ttroom.ttbuilding.long}`"
						role="link"
						:aria-label="$t('directions-to-destination')"
						target="_blank"
					>{{ $t('view-in-apple-maps') }}</a>
                </template>
            </div>

            <template v-if="$UserSession.hasPriv('APP_TEACHER') && event.checkincode">
            	<h1 class="mb-0">{{event.checkincode}}</h1>
				<div class="mb-1" v-if="event.checkincode">
					<img
						:src="`${$settings.APIBaseURL}/timetables/events/getqr?ttevent_id=${event.id}&username=${$UserSession.getValue('username')}&authToken=${$UserSession.getValue('authToken')}&size=md`"
					/>
				</div>
            </template>

            <template v-if="Object.values(students).length">
                <div class="text-sm font-weight-bold">{{ $t('attending') }}</div>
                <div v-for="name, i in Object.values(students)" :key="i">
                    {{ name }}
                </div>
            </template>

        </template>

        <template v-else>
            <p class="mb-0"><strong>{{ event.title }}</strong></p>
            <p class="mb-0" v-if="event.datefrom && event.dateto">
                {{ $datetime.timestampToDate(event.datefrom, false) }} -
                {{ $datetime.timestampToDate(event.dateto, false) }}
            </p>
        </template>

        <template #modal-footer>
            <div class="w-100">
                <b-button
                    variant="primary"
                    class="float-right"
                    @click="$emit('input', false)"
                >
                    {{ $t('ok') }}
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    props: {
        event: {
            type: Object,
            default: () => ({})
        },
        value: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            innerValue: this.value,
            students: {},
        }
    },
    watch: {
        value(newVal) {
            this.innerValue = newVal
        },
        event: {
            handler() {
                this.students = {}
                
                if (!this.event.students) return

                this.event.students.forEach(student => {
                    this.$users.getDisplayName.call(this, student.id).then(displayname => {
                        let temp = { ...this.students }
                        temp[student.id] = displayname
                        this.students = { ...temp }
                    })
                })
            },
            immediate: true,
        }
    }
}
</script>
